import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/hooks/useAdminAuth";

const CORPORATE_ADMIN_ALLOWED_PATHS = ["/admin/my-org"];

export const AdminAuthGuard = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated, isCorporateAdmin } = useAdminAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (
    isCorporateAdmin &&
    !CORPORATE_ADMIN_ALLOWED_PATHS.some((p) => location.pathname.startsWith(p))
  ) {
    return <Navigate to="/admin/my-org" replace />;
  }

  return <>{children}</>;
};
